export default "__VITE_ASSET__n6Lg55Nq__"